import React, { useState, useEffect } from "react";
import TableHeader from "./header";
import TableBody from "./tablebody";

const ReportData = ({ list }) => {
  const tableHead = Object.keys(list[0] || []);

  return (
    <>
      {list && (
        <table className="table table-striped table-hover">
          <thead className="thead-dark">
            <tr style={{ fontSize: "12px" }}>
              {tableHead.map((item, idex) => (
                <th key={item} scope="col">
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {list.map((element, index) => (
              <tr key={element.NO} style={{ fontSize: "12px" }}>
                {tableHead.map((item, index) => (
                  <td key={index}>{element[item]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default ReportData;
